const { getUserData } = require("./getUserData.js");

export const loadStudentData = async (currentUser, setMyCoreCourses) => {
  if (currentUser.roles.includes("Student")) {
    const studentCoreCourse = await getUserData("corecourse", currentUser);
    // console.log(studentCoreCourse)
    setMyCoreCourses(studentCoreCourse);
  }
};
